import { render, staticRenderFns } from "./IndexRedesignB.vue?vue&type=template&id=64f5a34c"
import script from "./IndexRedesignB.vue?vue&type=script&lang=js"
export * from "./IndexRedesignB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports